import moment from 'moment';

const sortAB = (tableData, checkedField, direction) => {
  return [
    ...tableData.sort((a, b) => {
      return direction > 0
        ? a[checkedField] < b[checkedField]
          ? 1
          : -1
        : b[checkedField] < a[checkedField]
        ? 1
        : -1;
    })
  ];
};

const sortBA = (tableData, checkedField, direction) => {
  return [
    ...tableData.sort((a, b) => {
      return direction > 0
        ? b[checkedField] < a[checkedField]
          ? 1
          : -1
        : a[checkedField] < b[checkedField]
        ? 1
        : -1;
    })
  ];
};

const sortDate = (tableData, checkedField, direction, sort, field) => {
  const tableDataPars = tableData.map(item => {
    return {
      ...item,
      [field]: moment(item[field], 'DD/MM/YYYY HH:mm').format('YYYYMMDDHHmm')
    };
  });
  const tableDataSort = sort(tableDataPars, checkedField, direction, field);

  return tableDataSort.map(item => {
    return {
      ...item,
      [field]: moment(item[field], 'YYYYMMDDHHmm').format('DD/MM/YYYY HH:mm')
    };
  });
};

export { sortAB, sortBA, sortDate };
